import {
  PrescriptionChainClient,
  PrescriptionChainMetadataClient,
  PlanningClient,
  RecurrencePatternsClient,
  PrescriptionsClient,
} from '@sekoia/shared/requests/nswagClients/NLLMedicineTasksClient';

export class NLLMedicineTasksContextClient {
  private _prescriptionChainClient: PrescriptionChainClient | undefined;
  public get prescriptionChainClient(): PrescriptionChainClient {
    if (!this._prescriptionChainClient) {
      this._prescriptionChainClient = new PrescriptionChainClient();
    }
    return this._prescriptionChainClient;
  }

  private _prescriptionChainMetadataClient: PrescriptionChainMetadataClient | undefined;
  public get prescriptionChainMetadataClient(): PrescriptionChainMetadataClient {
    if (!this._prescriptionChainMetadataClient) {
      this._prescriptionChainMetadataClient = new PrescriptionChainMetadataClient();
    }
    return this._prescriptionChainMetadataClient;
  }

  private _planningClient: PlanningClient | undefined;
  public get planningClient(): PlanningClient {
    if (!this._planningClient) {
      this._planningClient = new PlanningClient();
    }
    return this._planningClient;
  }

  private _recurrencePatternsClient: RecurrencePatternsClient | undefined;
  public get recurrencePatternsClient(): RecurrencePatternsClient {
    if (!this._recurrencePatternsClient) {
      this._recurrencePatternsClient = new RecurrencePatternsClient();
    }
    return this._recurrencePatternsClient;
  }

  private _prescriptionsClient: PrescriptionsClient | undefined;
  public get prescriptionsClient(): PrescriptionsClient {
    if (!this._prescriptionsClient) {
      this._prescriptionsClient = new PrescriptionsClient();
    }
    return this._prescriptionsClient;
  }
}
